import './../style/style.scss';
import './member-ajax-functions.js';
